/*
 * @Author: cc
 * @Date: 2019-12-08 19:24:26
 * @LastEditTime: 2021-03-19 20:00:32
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\broadcast\service\broadcastService.js
 * @Description: 
 */
'use strict';
angular.module('broadcastServiceModule', [])
    .factory('broadcastService', [function() {
        return {
        	getSearchType: function(){
        		return {
        			waitcompiled: 'broadcast.daibian',
        			pending: 'broadcast.daishen',
        			signed: 'broadcast.yiqianfa'
        		};
        	},
            getEditAndPreviewPath: function(){
                var path = {
                    edit: {
                        9: 'broadcastmanuscript', // 广电广电文稿
                        11: 'broadcastplannedorder' // 串联单
                    },
                    preview: {
                        9: 'broadcastmanuscriptPreview',
                        11: 'broadcastseriesSheetPreview'
                    }
                };
                return path;
            }
        };
    }]);
